const TOKEN_KEY = 'BONJIRI_ACCESS_TOKEN';

/**
 * トークン情報を扱うためのwrapperクラス
 */
class TokenManager {
  /**
   * 保存
   * @param {*} val
   */
  static set(val) {
    sessionStorage.setItem(TOKEN_KEY, val);
  }

  /**
   * 取得
   */
  static get() {
    return sessionStorage.getItem(TOKEN_KEY);
  }

  /**
   * トークンの削除
   */
  static remove() {
    sessionStorage.removeItem(TOKEN_KEY);
  }

  /**
   * ログイン状態の確認
   */
  static isLogin() {
    return !!sessionStorage.getItem(TOKEN_KEY);
  }
}

export default TokenManager;
